import React from 'react'
import Header from '../../Components/Header'
import EngineerOrProduction from '../../Components/chooseCapabilities'


function CapabilitesPage() {
  return (
    <div>
      <Header />
        <EngineerOrProduction />
    </div>

  )
}

export default CapabilitesPage